/** Force-sync blog title into every section image alt/title (title is master). */
export function applyTitleToSectionBlocks(blocks, title) {
  return (blocks || []).map((block) => ({
    ...block,
    imageAlt: title,
    imageTitle: title,
    _imageAltDirty: false,
    _imageTitleDirty: false,
  }));
}

/**
 * On edit load: keep values as-is; title remains master on next Name change.
 */
export function hydrateSectionImageDirtyFlags(blocks) {
  return (blocks || []).map((block) => ({
    ...block,
    _imageAltDirty: false,
    _imageTitleDirty: false,
  }));
}

/** New content section prefilled from current blog title. */
export function createEmptyContentBlock(title = "") {
  return {
    text: "",
    text_ur: "",
    textAlignment: "left",
    image: null,
    imageAlignment: "right",
    imageAlt: title || "",
    imageTitle: title || "",
    _imageAltDirty: false,
    _imageTitleDirty: false,
  };
}

/** After image upload: always fill alt/title from current blog title. */
export function applyTitleOnSectionImageUpload(block, title) {
  return {
    ...block,
    imageAlt: title,
    imageTitle: title,
    _imageAltDirty: false,
    _imageTitleDirty: false,
  };
}

/** Header image alt/title always follows blog title. */
export function applyBlogTitleToHeaderSeo(formPrev, title) {
  return {
    ...formPrev,
    name: title,
    header_image_title: title,
    header_image_alt: title,
  };
}
